function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M30.792 0C21.63.844 14.5 8.538 14.5 17.92v27.052C14.5 46.61 15.837 48 17.52 48h29.96c1.633 0 3.02-1.34 3.02-3.028V17.92C50.5 8.538 43.32.844 34.208 0"
}), React.createElement("path", {
  fill: "#C7D7E2",
  fillRule: "nonzero",
  d: "M33.975 8h-3.416c-.703.05-1.406.149-2.059.297 8.237 1.735 15.47 8.922 15.47 17.596v19.083c0 1.636-1.356 3.024-3.064 3.024h6.53c1.658 0 3.064-1.338 3.064-3.024V25.893c0-9.368-7.233-17.05-16.525-17.893z"
}), React.createElement("path", {
  fill: "#98BED8",
  fillRule: "nonzero",
  d: "M32 18a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M29.044 27c-.875 0-1.544-.67-1.544-1.544C27.5 22.47 29.92 20 32.956 20c.875 0 1.544.67 1.544 1.544 0 .875-.67 1.544-1.544 1.544a2.361 2.361 0 0 0-2.368 2.368c0 .875-.72 1.544-1.544 1.544z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M5 38a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
}), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M47.034 50H17.015c-2.48 0-4.515-2.036-4.515-4.518V26.415c0-7.995 4.763-15.095 12.206-18.074C26.89 7.447 29.37 7 31.95 7h.1c2.63 0 5.06.447 7.244 1.34A19.423 19.423 0 0 1 51.5 26.416V45.53c0 2.433-1.985 4.469-4.466 4.469zM31.95 9.98c-2.232 0-4.316.396-6.152 1.141-6.252 2.533-10.32 8.54-10.32 15.343v19.117c0 .844.694 1.54 1.537 1.54h30.02c.843 0 1.488-.696 1.488-1.54V26.415c0-6.753-4.069-12.811-10.32-15.343-1.837-.745-3.92-1.142-6.153-1.142h-.1v.05z"
}), React.createElement("path", {
  fill: "#C7D7E2",
  fillRule: "nonzero",
  d: "M47.064 45c-.89 0-1.534-.65-1.534-1.5s.643-1.5 1.485-1.5c.841 0 1.485.65 1.485 1.5s-.644 1.5-1.436 1.5zm-9.01 0c-.89 0-1.534-.65-1.534-1.5s.643-1.5 1.485-1.5c.842 0 1.485.65 1.485 1.5s-.643 1.5-1.436 1.5zm-9.01 0c-.89 0-1.534-.65-1.534-1.5s.643-1.5 1.485-1.5c.842 0 1.485.65 1.485 1.5s-.643 1.5-1.435 1.5zm-9.01 0h-.049c-.841 0-1.485-.65-1.485-1.5s.644-1.5 1.485-1.5h.05c.841 0 1.485.65 1.485 1.5s-.693 1.5-1.485 1.5z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M7.406 52.315a1.473 1.473 0 0 1-.549-2.05c.55-.952.22-2.182-.732-2.732a2.006 2.006 0 0 0-2.732.733 1.473 1.473 0 0 1-2.05.549 1.473 1.473 0 0 1-.548-2.05 5.015 5.015 0 0 1 6.83-1.83 5.015 5.015 0 0 1 1.83 6.83 1.473 1.473 0 0 1-2.049.55z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M14 33a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
}), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M14.5 40c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
}), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M6.945 47c-.283 0-.52-.099-.804-.247-.662-.445-.851-1.384-.378-2.076l5.109-8.007c.426-.692 1.324-.89 1.987-.395.662.444.851 1.383.378 2.075l-5.062 8.007a1.547 1.547 0 0 1-1.23.643z"
}), React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M51 33a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
}), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M50.5 40c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
}), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M58.076 47c-.477 0-.906-.248-1.193-.645l-5.151-8.032c-.43-.694-.239-1.587.381-2.082.668-.447 1.527-.248 2.004.396l5.151 8.033c.43.694.239 1.586-.381 2.082-.286.149-.573.248-.811.248z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M63.656 48.815a1.473 1.473 0 0 1-2.049-.55 2.006 2.006 0 0 0-2.732-.732 2.006 2.006 0 0 0-.732 2.733 1.473 1.473 0 0 1-.55 2.049 1.473 1.473 0 0 1-2.048-.55 5.015 5.015 0 0 1 1.83-6.83 5.015 5.015 0 0 1 6.83 1.83 1.473 1.473 0 0 1-.549 2.05z"
}), React.createElement("path", {
  fill: "#454B54",
  fillRule: "nonzero",
  d: "M45.408 54.11L41.707 49H23.3l-.963 1.313h1.926c.862 0 1.521.609 1.521 1.406 0 .797-.659 1.406-1.52 1.406h-3.956l-.71.984c-.253.375 0 .891.508.891H44.9c.456 0 .76-.516.507-.89zM32 9a1.612 1.612 0 0 1-1.497-1.721V5.613c0-.944.698-1.666 1.497-1.61.849 0 1.547.777 1.497 1.721V7.39C33.497 8.278 32.8 9 32 9z"
}));

var SvgMiniRobot = function SvgMiniRobot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 65,
    height: 55,
    viewBox: "0 0 65 55",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMiniRobot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mini-robot.5632add4.svg";
export { ForwardRef as ReactComponent };